var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CCard',[_c('CCardHeader',[_c('strong',[_vm._v("Signature")])]),_c('CCardBody',[_c('div',{staticClass:"border"},[(_vm.img)?[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.img}})]:_vm._e()],2),_c('div',{staticClass:"mt-3"},[(!_vm.img)?_c('p',[_vm._v("No signature")]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }